import React from 'react'
import { Box, Card } from '@mui/material'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import WTypography from 'Components/whiteTypography'
import CustomButton from 'Components/CustomButton/CustomButton'

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

function createCalendar(currentDate) {
  if (!currentDate) {
    currentDate = moment()
  } else {
    currentDate = moment(currentDate)
  }

  const first = currentDate.clone().startOf('month')
  const last = currentDate.clone().endOf('month')
  const weeksCount = Math.ceil((first.day() + last.date()) / 7)
  const calendar = Object.assign([], { currentDate, first, last })

  for (let weekNumber = 0; weekNumber < weeksCount; weekNumber++) {
    const week = []
    calendar.push(week)
    calendar.year = currentDate.year()
    calendar.month = currentDate.month()

    for (let day = 7 * weekNumber; day < 7 * (weekNumber + 1); day++) {
      const date = currentDate.clone().set('date', day + 1 - first.day())
      date.calendar = calendar
      week.push(date)
    }
  }
  return calendar
}
function CalendarDate(props) {
  const { dateToRender, dateOfMonth, events = [] } = props
  var startArray = events.map(function (e) {
    return moment(e.start_date, 'DD-MM-YYYY').format('YYYY-MM-DD')
  })
  const today = dateToRender.format('YYYY-MM-DD') === moment().format('YYYY-MM-DD') ? 'today' : ''
  const event = startArray.find((e) => e === dateToRender.format('YYYY-MM-DD'))

  if (dateToRender.month() < dateOfMonth.month()) {
    return (
      <button disabled={true} className="date prev-month">
        {dateToRender.date()}
      </button>
    )
  }

  if (dateToRender.month() > dateOfMonth.month()) {
    return (
      <button disabled={true} className="date next-month">
        {dateToRender.date()}
      </button>
    )
  }

  return (
    <button
      className={`date in-month ${today} ${event ? 'year-event' : ''}`}
      onClick={() => props.onClick(dateToRender)}
    >
      {dateToRender.date()}
    </button>
  )
}

class Calendar extends React.Component {
  state = {
    calendar: undefined,
  }

  componentDidMount() {
    this.setState({ calendar: createCalendar(this.props.date) })
  }

  componentDidUpdate(prevProps) {
    if (this.props.date !== prevProps.date) {
      this.setState({ calendar: createCalendar(this.props.date) })
    }
  }

  render() {
    if (!this.state.calendar) {
      return null
    }

    return (
      <div className="month">
        <Box display={'flex'} justifyContent={'space-between'}>
          <div
            className="month-name"
            style={{ marginLeft: '6px', color: 'white', cursor: 'pointer' }}
            onClick={() => {
              this.setState({ calendar: createCalendar(new Date()) })
              this.props.onMonthChange()
            }}
          >
            {this.props.t ? this.props.t('syntheseTemps.today') : 'Today'}
          </div>
          <Box>
            <CustomButton
              style={{ minWidth: 'unset', height: '35px' }}
              onClick={() => {
                this.setState({
                  calendar: createCalendar(this.state.calendar.currentDate.add(-1, 'months')),
                })
              }}
            >
              <KeyboardArrowLeftIcon />
            </CustomButton>
            <Box component={'span'} sx={{ color: 'white', padding: '0px 10px' }}>
              {this.state.calendar.currentDate.format('MMMM yy').toUpperCase()}
            </Box>
            <CustomButton
              style={{ minWidth: 'unset', height: '35px' }}
              onClick={() => {
                this.setState({
                  calendar: createCalendar(this.state.calendar.currentDate.add(1, 'months')),
                })
              }}
            >
              <KeyboardArrowRightIcon />
            </CustomButton>
          </Box>
        </Box>
        <div style={{ display: 'flex', justifyContent: 'space-evenly', color: '#a2a2a2' }}>
          {(this.props.t
            ? [
                this.props.t('syntheseTemps.dayShortSun'),
                this.props.t('syntheseTemps.dayShortMon'),
                this.props.t('syntheseTemps.dayShortTue'),
                this.props.t('syntheseTemps.dayShortWed'),
                this.props.t('syntheseTemps.dayShortThu'),
                this.props.t('syntheseTemps.dayShortFri'),
                this.props.t('syntheseTemps.dayShortSat'),
              ]
            : ['Di.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.']
          ).map((day, index) => (
            <span key={index} className="day">
              {day}
            </span>
          ))}
        </div>
        {this.state.calendar.map((week, index) => (
          <div
            key={index}
            style={{ display: 'flex', justifyContent: 'space-evenly', marginBottom: '5px' }}
          >
            {/* {week[0].week()} */}
            {week.map((date) => (
              <CalendarDate
                events={this.props.events}
                key={date.date()}
                dateToRender={date}
                dateOfMonth={this.state.calendar.currentDate}
                onClick={(date) => this.props.onDrillDown(date)}
              />
            ))}
          </div>
        ))}
      </div>
    )
  }
}

function MonCalander({ oldData, updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const siteUser = useSelector((store) => store.user)
  let time_formate = siteUser.user?.user_parameter?.format_de_lheure
  const navigate = useNavigate()

  const [events, setEvents] = useState(
    oldData.filter((e) => e.start_date === moment().format('DD-MM-YYYY')),
  )

  useEffect(() => {
    // console.log(moment().format('DD-MM-YYYY'))
  }, [])
  const filterEvents = (date) => {
    setEvents(oldData.filter((e) => e.start_date === date.format('DD-MM-YYYY')))
  }
  const allEvents = () => {
    setEvents(oldData)
  }

  return (
    <>
      <Card className="dashboard_card__root1">
        <Box className="dashboard_card__header1 no-drag" onClick={() => navigate('/MonCalendrier')}>
          <WTypography component={'span'} variant="h6">
            {t('syntheseTemps.calendarTitle')}
          </WTypography>
          <WTypography component={'span'} variant="h6">
            {events.length}
          </WTypography>
        </Box>
        <Box className="dashboard_card__header1">
          <WTypography sx={{ color: '#ffffffa1' }} variant={'body2'}>
            {t('syntheseTemps.calendarSubtitle')}
          </WTypography>
        </Box>
        <Box display={'flex'} flexDirection={'column'} height={'100%'} pb={'50px'}>
          <Box mb={1} className="no-drag">
            <Calendar
              date={new Date()}
              events={oldData}
              onDrillDown={filterEvents}
              onMonthChange={allEvents}
              t={t}
            />
          </Box>
          <Box sx={{ color: 'white', overflowY: 'auto' }} px={2}>
            {events.map((e) => (
              <Box key={e.id} display={'flex'} pb={1}>
                <Box
                  display={'flex'}
                  justifyContent={'right'}
                  flexDirection={'column'}
                  textAlign={'right'}
                  width={'65px'}
                >
                  <Box fontWeight={700} fontSize={18}>
                    {moment(e.start_time, 'hh:mm:ss').format(
                      time_formate === '24h' ? 'HH:mm' : 'hh:mm',
                    )}
                  </Box>
                  <Box color={'#b9b8b8'} fontSize={12}>
                    {parseInt(
                      moment
                        .duration(
                          moment(e.end_date + ' ' + e.end_time, 'DD-MM-YYYY hh:mm:ss').diff(
                            moment(e.start_date + ' ' + e.start_time, 'DD-MM-YYYY hh:mm:ss'),
                          ),
                        )
                        .asHours(),
                    )}{' '}
                    {t('syntheseTemps.hoursSuffix')}
                  </Box>
                </Box>
                <Box sx={{ backgroundColor: '#4da3ed', padding: '0 5px', margin: '0 8px' }}></Box>
                <Box>
                  <Box fontWeight={700} fontSize={18}>
                    {e.titre}
                  </Box>
                  <Box color={'#b9b8b8'} fontSize={12}>
                    {e.designation}
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Card>
    </>
  )
}

export default MonCalander
